export default "__VITE_ASSET__BRiN0XWn__"